import { render, staticRenderFns } from "./AreaLocationSetup.vue?vue&type=template&id=6a0ea829&scoped=true"
import script from "./AreaLocationSetup.vue?vue&type=script&lang=ts"
export * from "./AreaLocationSetup.vue?vue&type=script&lang=ts"
import style0 from "./AreaLocationSetup.vue?vue&type=style&index=0&id=6a0ea829&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0ea829",
  null
  
)

export default component.exports